import { t } from "../i18n";

export default function PlaylistModal({
  tracks,
  currentTrackId,
  sourceType = "playlist",
  onRemove,
  onClear,
  onPlay,
  onClose,
  lang = 'zh',
}) {
  const isEmpty = tracks.length === 0;
  const isPlaylist = sourceType === "playlist";

  const titleKey =
    sourceType === "liked" ? "likedSource" :
    sourceType === "favorites" ? "favoritesSource" :
    sourceType === "explore" ? "exploreSource" :
    "playlistSource";

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className="bg-white rounded-2xl shadow-2xl overflow-hidden max-w-md w-full max-h-[70vh] flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between px-5 py-4 border-b border-gray-100 shrink-0">
          <h3 className="font-bold text-gray-900">{t(lang, titleKey)}</h3>
          <div className="flex items-center gap-2">
            {isPlaylist && tracks.length > 0 && (
              <button
                onClick={onClear}
                className="px-3 py-1.5 text-xs text-red-500 hover:bg-red-50 rounded-lg transition"
              >
                {t(lang, 'clearPlaylist')}
              </button>
            )}
            <button
              onClick={onClose}
              className="w-8 h-8 rounded-full flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <path d="M18 6L6 18M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>

        {/* List */}
        <div className="flex-1 overflow-y-auto">
          {isEmpty ? (
            <div className="flex flex-col items-center justify-center py-12 text-gray-400">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="mb-3 opacity-50">
                <path d="M9 18V5l12-2v13" />
                <circle cx="6" cy="18" r="3" />
                <circle cx="18" cy="16" r="3" />
              </svg>
              <span className="text-sm">{t(lang, 'playlistEmpty')}</span>
            </div>
          ) : (
            tracks.map((track, i) => (
              <div
                key={track.id || i}
                className={`flex items-center gap-3 px-4 py-3 border-b border-gray-100 last:border-0 transition ${
                  track.id === currentTrackId ? 'bg-indigo-50' : 'hover:bg-gray-50'
                }`}
              >
                {/* Number / Now playing icon */}
                <span className="w-6 text-center text-xs text-gray-400 font-mono shrink-0">
                  {track.id === currentTrackId ? (
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" className="text-indigo-500 mx-auto">
                      <path d="M8 5v14l11-7z" />
                    </svg>
                  ) : (
                    i + 1
                  )}
                </span>

                {/* Info */}
                <div
                  className="flex-1 min-w-0 cursor-pointer"
                  onClick={() => onPlay(track)}
                >
                  <div className="font-medium text-sm text-gray-900 truncate">
                    {track.name || `${t(lang, 'track')} ${i + 1}`}
                  </div>
                  {track.type && (
                    <div className="text-xs text-gray-400">
                      {track.type === "songs" ? t(lang, 'vocal') : t(lang, 'instrumental')}
                    </div>
                  )}
                </div>

                {/* Remove (only for playlist source) */}
                {isPlaylist && (
                  <button
                    onClick={() => onRemove(i)}
                    className="w-7 h-7 rounded-full flex items-center justify-center text-gray-400 hover:text-red-500 hover:bg-red-50 transition shrink-0"
                    title={t(lang, 'removeFromPlaylist')}
                  >
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M18 6L6 18M6 6l12 12" />
                    </svg>
                  </button>
                )}
              </div>
            ))
          )}
        </div>

        {/* Footer */}
        {tracks.length > 0 && (
          <div className="px-4 py-3 bg-gray-50 border-t border-gray-100 text-center text-xs text-gray-400 shrink-0">
            {tracks.length} {t(lang, 'tracks')}
          </div>
        )}
      </div>
    </div>
  );
}
